import { put, takeLatest, takeEvery } from 'redux-saga/effects';
import { delay } from '@services/sagas';
import { types as sidebarTypes, closeSidebar } from '@actions/sidebar';
import { push } from 'react-router-redux';

export function* waitAndHideSnackbar(action) {
  if (action.active) {
    yield delay(15000);
    yield put(closeSidebar(action.active));
  }
}

export function* pushToRoute(action) {
  yield put(push(action.route));
}

export default function*() {
  yield takeEvery(sidebarTypes.PUSH, pushToRoute);
  yield takeLatest(sidebarTypes.PUSH, waitAndHideSnackbar);
}



// WEBPACK FOOTER //
// ./redux/sagas/sidebar.js